import { authStatusStore } from 'src/queries/authStatusStore'
import { RootState } from 'src/redux/createRootReducer'

/** Interop helpers bridging Redux state.auth to the reactive authStatusStore. See src/queries/AGENTS.md. */

/**
 * Mirror the current Redux `state.auth.{isAuthenticated,isCspAuthenticated}` into
 * `authStatusStore` (both flags in one write). `setAuthStatus` diffs each field, so an
 * unchanged state is a no-op (no listener notify), and a change to only one flag
 * notifies once.
 */
export const syncAuthStatusStoreFromState = (state: RootState): void => {
  authStatusStore.setAuthStatus({
    isAuthenticated: state.auth.isAuthenticated,
    isCspAuthenticated: state.auth.isCspAuthenticated,
  })
}

/**
 * Prime `authStatusStore` from the store's current (SSR-seeded, hydrated) auth state.
 * Call once on the browser entry after the store is created and before the first
 * render — the write-through middleware only fires on subsequent dispatches, so
 * without this the initial hydrated flag would be missing and the reactive render
 * gate could flash the wrong auth state on hydration.
 */
export const primeAuthStatusStore = (store: {
  getState: () => RootState
}): void => {
  syncAuthStatusStoreFromState(store.getState())
}
